export default __webpack_public_path__ + "static/media/icon_type.bd422ff8.svg";